module.exports = __webpack_public_path__ + "static/media/check-mark.1b1d3d0a.svg";